import { inject, Injector } from '@angular/core';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';
import {
	FiltersConfig,
	FilterTypeEnum,
} from '../../../../shared/models/filters-config';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../shared/tokens/searchable-strategy.token';
import { TagSearchStrategy } from '../../tags/config/tag-searchable-strategy';
import { VehicleSearchStrategy } from '../../vehicles/config/vehicle-searchable-strategy';
import { VEHICLE_ROAD_TAX_STATUSES } from '../translations/vehicle-road-taxes-select-items';
import { VehicleRoadTaxesService } from '../vehicle-road-taxes.service';

export function getVehicleRoadTaxFilters(): FiltersConfig[] {
	const injector = inject(Injector);
	const service = inject(VehicleRoadTaxesService);
	return [
		{
			title: 'road-taxes|filter|statuses',
			options: VEHICLE_ROAD_TAX_STATUSES,
			type: FilterTypeEnum.MULTI,
			selected$: service.vehicleRoadTaxesFilters.statuses$,
		},
		...(FEATURES.vehicles
			? [
					{
						title: 'road-taxes|filter|vehicles',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.VEHICLES,
						selected$: service.vehicleRoadTaxesFilters.vehicles$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: VehicleSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
		...(FEATURES.tags
			? [
					{
						title: 'road-taxes|filter|tags',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.TAGS,
						selected$: service.vehicleRoadTaxesFilters.tags$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: TagSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
	];
}
